import { deleteVisita, getVisitasPanel, getRutasPanel } from "../../services/VisitasServices";
import { VisitasContext } from "./VisitasContext"

export const VisitasState = ({ children }) => {

    const getVisitasPanelData = async (selId, cliId, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido, numpag, filas) => {
        let res = await getVisitasPanel(selId, cliId, dateFrom, dateUntil, hourFrom, hourUntil, tienePedido, numpag, filas)
        return res
    }

    const getRutasPanelData = async (selId, dateSelected, hourFrom, hourUntil) => {
        let res = await getRutasPanel(selId, dateSelected, hourFrom, hourUntil)
        return res
    }

    const deleteVisitaData = async (body, search, numpag, filas) => {
        const res = await deleteVisita(body)
        if (res) getVisitasPanelData(search, numpag, filas)
        return res
    }

    return <VisitasContext.Provider value={{
        deleteVisitaData,
        getVisitasPanelData,
        getRutasPanelData,
    }} >
        {children}
    </VisitasContext.Provider>
}